import React, { useCallback } from 'react'
import { Button, Form, Input, Card, Checkbox, Alert } from 'antd'
import { UserOutlined, MailOutlined, UnlockOutlined } from '@ant-design/icons'
import { useNavigate } from "react-router-dom"
// 验证码
import Captcha from 'react-captcha-code'
//导入样式
import '@/scss/common.scss'
//引入图片
import leftImage from '@/assets/images/logo_left.jpg'

import { decrypt, encrypt } from '@/utils'

//mobx
import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { runInAction, set } from 'mobx'


const Login = () => {
  //路由跳转
  const navigate = useNavigate()
  //登录
  const { LoginStore } = useStore()

  // 验证码
  const handleClick = useCallback((captcha) => {
    runInAction(() => {
      set(LoginStore, { captcha: captcha })
    })
  }, [LoginStore])

  //登录
  const onFinish = async (values) => {
    console.log(values)
    const encryptText = encrypt(values.password)
    set(LoginStore, { remember: values.remember })
    set(LoginStore, { username: values.username })
    set(LoginStore, { password: encryptText })
    await LoginStore.getToken(values)
  }

  return (
    <>
      <div className='login'>
        <Card className='login-container'>
          <div className='left-img'>
            <img src={leftImage} alt='' />
          </div>
          <div className='right-input'>
            <div className='right-nr'>
              <h1 className='logo-text'>欢迎登录</h1>
              <h2 className='logo-title'>玉米水肥一体化应用云服务</h2>
              {/* <h3>还没有账号？<a onClick={() => { navigate("/register") }}>我要注册</a></h3> */}
              <div>
                {LoginStore.isActive ? (
                  <Alert message="密码输入超过5次" type="warning" showIcon style={{ marginBottom: '15px' }} />
                ) : null}
              </div>
              <Form onFinish={onFinish} initialValues={{
                remember: LoginStore.remember,
                username: LoginStore.username,
                password: decrypt(LoginStore.password)
              }}>
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: '请输入账户',
                    },
                  ]}
                >
                  <Input size="large" placeholder="请输入账户" prefix={<UserOutlined className="icon" />} />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: '请输入密码',
                    },
                  ]}
                  autoComplete="off"
                >
                  <Input.Password size="large" placeholder="请输入密码" prefix={<UnlockOutlined className="icon" />} />
                </Form.Item>
                <Form.Item >
                  <div className='fdbj'>
                    <div className='fdbj-left'>
                      <Form.Item
                        name="code"
                        rules={[
                          { len: 4, message: '验证码4个字符', validateTrigger: 'onBlur' },
                          { required: true, message: '请输入验证码' }
                        ]}
                        noStyle
                      >
                        <Input size="large" placeholder="请输入验证码" maxLength={4} prefix={<MailOutlined className="icon" />} />
                      </Form.Item>
                    </div>
                    <div className='fdbj-right'>
                      <Captcha charNum={4} onChange={handleClick} />
                    </div>
                  </div>
                </Form.Item>
                <Form.Item>
                  <Form.Item name="remember" valuePropName="checked" noStyle>
                    <Checkbox>记住密码{LoginStore.remember}</Checkbox>
                  </Form.Item>
                  {/* <a className="login-form-forgot" href="" onClick={() => {
                    navigate("/password")
                  }}>
                    忘记密码
                  </a> */}
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" className="login-form-button">
                    立即登录
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Card>
      </div>
    </>
  )
}
export default observer(Login)